import Provider from "provider";
import { PUBLISH_STATUS } from "../lifecycle";

/**
 * Manual status-override menu items, shared by the header status pill and the
 * Game Home hero CTA caret. Offers every primary lifecycle status except the
 * one the game is already in (and except archived — that lives in Settings,
 * since restoring runs a reset). Each item writes the override via
 * Provider.setGameStatus; the Firebase listener re-renders on the change.
 */
const LABELS = {
  [PUBLISH_STATUS.DRAFT]: "Draft",
  [PUBLISH_STATUS.READY]: "Ready",
  [PUBLISH_STATUS.IN_PROGRESS]: "In progress",
  [PUBLISH_STATUS.PLAYED]: "Played",
};

const ORDER = [
  PUBLISH_STATUS.DRAFT,
  PUBLISH_STATUS.READY,
  PUBLISH_STATUS.IN_PROGRESS,
  PUBLISH_STATUS.PLAYED,
];

/**
 * @param {string} currentStatus - the game's raw publishStatus (not the
 *   "awaiting" display pseudo-status)
 * @param {string} gameId
 * @param {(err: Error) => void} [onError]
 * @returns {{ label: string, onClick: () => Promise<void> }[]}
 */
export const statusOverrideItems = (currentStatus, gameId, onError) =>
  ORDER.filter((s) => s !== currentStatus).map((s) => ({
    label: `Set status: ${LABELS[s]}`,
    onClick: async () => {
      try {
        await Provider.setGameStatus(gameId, s);
      } catch (err) {
        if (onError) onError(err);
      }
    },
  }));
